import { connectSortBy } from 'instantsearch.js/es/connectors'
import customSelect from 'custom-select'
import { get } from '@bigyouth/base'

let sortByInit = false

const renderSortBy = (renderOptions, isFirstRender) => {
  const {
    options,
    currentRefinement,
    refine,
    widgetParams,
  } = renderOptions

  const urlParams = new URLSearchParams(window.location.search)
  const themeInUrl = urlParams.get('theme')

  if (!isFirstRender && !sortByInit) {
    if (sessionStorage.getItem('sort') && sessionStorage.getItem('prevUrl').includes('/formations/')) {
      if (!themeInUrl) {
        refine(sessionStorage.getItem('sort'))
        get('[js-training-list-sort] select').value = sessionStorage.getItem('sort')
      }

      sessionStorage.removeItem('sort')
    }

    sortByInit = true
  }

  if (isFirstRender) {
    const select = document.createElement('select')

    widgetParams.container.appendChild(select)

    select.innerHTML = `
      ${options.map(option => `
        <option value="${option.value}" ${option.value === currentRefinement ? 'selected' : ''}>
          ${option.label}
        </option>`).join('')}`
  } else {
    if (!widgetParams.container.querySelector('.custom-select-container')) {
      const customSelectEl = customSelect(widgetParams.container.querySelector('select'))

      const iconContainer = document.createElement('div')
      iconContainer.innerHTML = `
        <div class="custom-select-icon-wrapper">
          <svg class="custom-select-icon">
            <use href="#icon-chevron-down" xlink:href="#icon-chevron-down"></use>
          </svg>
        </div>
      `

      customSelectEl[0].container.appendChild(iconContainer.firstElementChild)

      customSelectEl[0].select.addEventListener('change', (e) => {
        refine(e.target.value)
      })
    }
  }
}

const customSortBy = connectSortBy(renderSortBy)

export default customSortBy
